module.exports = __webpack_public_path__ + "img/logo.fe04706f.png";